// utils
import { isBrowserEnv } from "utils/bridgeSdk";

export function getAppHostName() {
    return isBrowserEnv() && window.location && window.location.hostname ? window.location.hostname : "";
}

export function getUserAgent() {
    return isBrowserEnv() && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : "";
}
